import { useRef, useState } from "react";
import { UploadCloud } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { errMsg } from "@/lib/api";
import { uploadChunked } from "@/lib/portalApi";

const ACCEPT = ".pdf,.ai,.eps,.psd,.tif,.tiff,.jpg,.jpeg,.png,.svg,.indd,.cdr,.zip,.webp";

// Uploads in 5 MB chunks, then calls onUploaded(upload_id) to attach the file.
export function FileUploadButton({ client, base, onUploaded, label = "Upload file", testId, variant = "outline", className }) {
  const ref = useRef(null);
  const [pct, setPct] = useState(null);
  const pick = async (file) => {
    if (!file) return;
    if (file.size > 100 * 1024 * 1024) { toast.error("Files must be 100 MB or smaller"); return; }
    setPct(0);
    try {
      const id = await uploadChunked(client, base, file, setPct);
      await onUploaded(id, file);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setPct(null);
      if (ref.current) ref.current.value = "";
    }
  };
  return (
    <>
      <input ref={ref} type="file" accept={ACCEPT} className="hidden" data-testid={`${testId}-input`} onChange={(e) => pick(e.target.files[0])} />
      <Button type="button" variant={variant} disabled={pct !== null} data-testid={testId} onClick={() => ref.current?.click()} className={className}>
        <UploadCloud className="mr-1 h-4 w-4" />{pct !== null ? `Uploading ${pct}%` : label}
      </Button>
    </>
  );
}

export const fsize = (b) => (b > 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);
